import axios from "axios"
import { HEADER_QUERY, HEADERS } from "../../../../../API/UrlAndPaths"
import store from "../../../../../Redux/store"
import { listPosNotes, setPageIndexForViewOrder, setPaginationForViewOrder, setTableLoading, storeHeldOrders, storeOrdersList } from "../Slice/viewOrdersBillingSlice"
import { setTableLoadingGlobal } from "../../../../../Redux/Dashboard/mainDashBoardSlice"
import { setBillLoading, setDialogBox, setErrorSnack, setOrderIdInPOS, setSingleOrderInfo, setSnackMsg, setSuccessSnack } from "../Slice/billingScreenSlice"
import { setFilterPopup } from "../Utilities/filterButtonSlice"
import { setAuthPassword } from "../newBillingSlice"
import { setOngoingOrderCount } from "../Components/topBarSliceBilling"

export const listOrdersForBillingAPI=async(body)=>{


    store.dispatch(setTableLoading(true))
    await axios.post("pos/listPosOrders",body,HEADERS)
        .then((res)=>{
            // Handle both online (200) and offline (202/cached) responses
            if(res.status===200 || res.status===202){
                const isOffline = res.status === 202 || res.headers?.['x-from-cache'] === 'true' || res.headers?.['x-from-offline'] === 'true';
                console.log(`📋 Orders list received${isOffline ? ' (offline/cached)' : ''}: ${res.data?.length || 0} orders`);
                store.dispatch(storeOrdersList(res.data))
                store.dispatch(setTableLoading(false))
                store.dispatch(setPaginationForViewOrder(false))
                store.dispatch(setPageIndexForViewOrder(0))
                store.dispatch(setFilterPopup(false))
            }
        })
        .catch((err)=>{
             store.dispatch(storeOrdersList([]))
            store.dispatch(setTableLoading(false))
        })
}
export const listOrdersPaginationAPI=async(body)=>{
    const isPagination = store.getState().viewOrdersBillingSlice.pagination;

    store.dispatch(setTableLoadingGlobal(true))
    await axios.post("pos/listPosOrders",body,HEADERS)
        .then((res)=>{
            // Handle both online (200) and offline (202/cached) responses
            if(res.status===200 || res.status===202){
                const existingProductsList = store.getState().viewOrdersBillingSlice.ordersList;
                const updatedOrdersList = existingProductsList.concat(res.data);


                // Remove duplicates from the updatedProductsList
                const uniqueOrderList = updatedOrdersList.filter((product, index, self) => (
                    index === self.findIndex((p) => (
                    p._id === product._id 
                    ))
                ));
                store.dispatch(storeOrdersList(uniqueOrderList))
                store.dispatch(setTableLoadingGlobal(false))
                store.dispatch(setPaginationForViewOrder(false))
            }
        })
        .catch((err)=>{
            err.response?.status===404 && store.dispatch(setPaginationForViewOrder(isPagination && 'max'))
            store.dispatch(setTableLoadingGlobal(false))
        })
}
export const listHeldOrders=async(body)=>{

    store.dispatch(setTableLoading(true))
    await axios.post("pos/listPosOrders",body,HEADERS)
        .then((res)=>{
            // Handle both online (200) and offline (202/cached) responses
            if(res.status===200 || res.status===202){
                const isOffline = res.status === 202 || res.headers?.['x-from-cache'] === 'true' || res.headers?.['x-from-offline'] === 'true';
                console.log(`📦 Held orders received${isOffline ? ' (offline/cached)' : ''}: ${res.data?.length || 0} orders`);
                store.dispatch(setOngoingOrderCount((res?.data)?.length || 0))

                store.dispatch(setTableLoading(false))
                store.dispatch(storeHeldOrders(res.data))
                store.dispatch(setFilterPopup(false))
            }
        })
        .catch((err)=>{
            store.dispatch(setOngoingOrderCount(0))
            store.dispatch(setTableLoading(false))
            store.dispatch(storeHeldOrders([]))
        })
}


export const deleteBookingOrder=async(body,clearFn)=>{
    store.dispatch(setBillLoading(true))
    await axios.post("pos/deleteBookingOrder",body,HEADERS)
        .then((res)=>{
            if(res.status===200){
                // Remove cancelled booking from heldOrders list immediately
                const currentHeldOrders = store.getState().viewOrdersBillingSlice.heldOrders;
                const updatedHeldOrders = currentHeldOrders.filter(order => order._id !== body.orderId);
                store.dispatch(storeHeldOrders(updatedHeldOrders));
                
                clearFn()
                store.dispatch(setOrderIdInPOS(null))                
                store.dispatch(setSingleOrderInfo(null))                
                store.dispatch(setBillLoading(false))                    
                store.dispatch(setSnackMsg("Booking Cancelled"))
                store.dispatch(setSuccessSnack(true))  
                store.dispatch(setAuthPassword(""))
                store.dispatch(setDialogBox(null))                
            }
        })
        .catch((err)=>{
            let message=err.response.status===500?"Internal Server Error !!":err.response.data||"Network Error !!"
            store.dispatch(setSnackMsg(message))
            store.dispatch(setBillLoading(false))                
            store.dispatch(setErrorSnack(true))
        })
}
export const cancelOngoingOrderApiCall=async(body,clearFn)=>{
    store.dispatch(setBillLoading(true))
    
    await axios.post("pos/cancelOngoingOrders",body,HEADERS)
    .then((res)=>{
        if(res.status===200 || res.status===202){
                const isOffline = res.status === 202;
                
                // Remove cancelled order from heldOrders list immediately
                const currentHeldOrders = store.getState().viewOrdersBillingSlice.heldOrders;
                const updatedHeldOrders = currentHeldOrders.filter(order => order._id !== body.orderId);
                store.dispatch(storeHeldOrders(updatedHeldOrders));
                
                store.dispatch(setAuthPassword(""))
                store.dispatch(setDialogBox(null))        
                clearFn()
                store.dispatch(setOrderIdInPOS(null))                
                store.dispatch(setSingleOrderInfo(null))                
                store.dispatch(setBillLoading(false))                    
                store.dispatch(setSnackMsg(isOffline ? "Order cancelled (offline - will sync)" : "Order Cancelled"))
                store.dispatch(setSuccessSnack(true))           
            }
        })
        .catch((err)=>{
            let message=err.response?.status===500?"Internal Server Error !!":err.response?.data||"Network Error !!"
            store.dispatch(setSnackMsg(message))
            store.dispatch(setBillLoading(false))                
            store.dispatch(setErrorSnack(true))
        })
}

// Cancel all ongoing orders
export const cancelAllOngoingOrdersApiCall = async (orders, branchId, password, clearFn) => {
    store.dispatch(setBillLoading(true))
    
    let successCount = 0;
    let failCount = 0;
    
    for (const order of orders) {
        try {
            const body = {
                orderId: order._id,
                branchId: branchId,
                password: password
            };
            
            // Use different API based on order status
            const endpoint = order.status === "DRAFT" ? "pos/cancelOngoingOrders" : "pos/deleteBookingOrder";
            
            const res = await axios.post(endpoint, body, HEADERS);
            if (res.status === 200 || res.status === 202) {
                successCount++;
            }
        } catch (err) {
            console.error(`Failed to cancel order ${order._id}:`, err);
            failCount++;
        }
    }
    
    // Clear all held orders from state
    store.dispatch(storeHeldOrders([]));
    store.dispatch(setAuthPassword(""));
    store.dispatch(setDialogBox(null));
    store.dispatch(setOrderIdInPOS(null));
    store.dispatch(setSingleOrderInfo(null));
    store.dispatch(setBillLoading(false));
    
    if (clearFn) clearFn();
    
    if (failCount === 0) {
        store.dispatch(setSnackMsg(`All ${successCount} orders cancelled successfully`));
        store.dispatch(setSuccessSnack(true));
    } else {
        store.dispatch(setSnackMsg(`${successCount} orders cancelled, ${failCount} failed`));
        store.dispatch(setErrorSnack(true));
    }
}
// Fallback: localStorage-based note templates when backend is unavailable
const LOCAL_NOTES_KEY = 'pos_note_templates';

const getLocalNotes = () => {
  try {
    const stored = localStorage.getItem(LOCAL_NOTES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const saveLocalNotes = (notes) => {
  try {
    localStorage.setItem(LOCAL_NOTES_KEY, JSON.stringify(notes));
  } catch (e) {
    console.error('Failed to save notes to localStorage', e);
  }
};

export const listPosNotesApiCall =(body)=>{
  // Try lowercase first (most backends), then camelCase as fallback
  axios.post("pos/listposNotes", body, HEADERS)
    .then((res)=>{
      if(res.status===200){
        store.dispatch(listPosNotes({listNotes:res.data}))
      }
    })
    .catch(async (err)=>{
      try {
        const res = await axios.post("pos/listPosNotes", body, HEADERS)
        if(res.status===200){
          store.dispatch(listPosNotes({listNotes:res.data}))
        }
      } catch (e2) {
        // Fallback to localStorage
        const localNotes = getLocalNotes();
        store.dispatch(listPosNotes({listNotes: localNotes}))
      }
    })
}
export const createPosNoteApiCall = async (body, onDone) => {
  // body: { branchId, notes }
  store.dispatch(setBillLoading(false))
  try {
    await axios.post("pos/addposNotes", body, HEADERS)
    store.dispatch(setBillLoading(false))
    typeof onDone === 'function' && onDone()
  } catch (err) {
    store.dispatch(setBillLoading(false))
    // Fallback: save to localStorage
    const localNotes = getLocalNotes();
    const newNote = { _id: Date.now().toString(), notes: body.notes, branchId: body.branchId };
    localNotes.push(newNote);
    saveLocalNotes(localNotes);
    store.dispatch(listPosNotes({listNotes: localNotes}))
    typeof onDone === 'function' && onDone()
  }
}

export const updatePosNoteApiCall = async (body, onDone) => {
  // body: { noteId, notes }
  store.dispatch(setBillLoading(true))
  try {
    await axios.put("pos/updatePosNoteById", body, HEADERS)
    store.dispatch(setBillLoading(false))
    typeof onDone === 'function' && onDone()
  } catch (err) {
    store.dispatch(setBillLoading(false))
    // Fallback: update in localStorage
    const localNotes = getLocalNotes();
    const idx = localNotes.findIndex(n => n._id === body.noteId);
    if (idx >= 0) {
      localNotes[idx].notes = body.notes;
      saveLocalNotes(localNotes);
      store.dispatch(listPosNotes({listNotes: localNotes}))
    }
    typeof onDone === 'function' && onDone()
  }
}
export const deleteNoteApiCall =(body,viewNotes)=>{
    store.dispatch(setBillLoading(true))   
    axios.delete("pos/deletePosNoteById",{headers:HEADER_QUERY,data:body})
    .then((res)=>{
      if(res.status===200){
        store.dispatch(setBillLoading(false))
        viewNotes()
      }
    })
    .catch((err)=>{
        store.dispatch(setBillLoading(false))
        // Fallback: delete from localStorage
        const localNotes = getLocalNotes();
        const filtered = localNotes.filter(n => n._id !== body.noteId);
        saveLocalNotes(filtered);
        store.dispatch(listPosNotes({listNotes: filtered}))
        typeof viewNotes === 'function' && viewNotes()
    })
  
  }